import React from 'react';
import { Outlet, Route } from 'react-router';

import ErrorPage from 'app/components/ErrorPage';
import PrintLayout from 'app/components/shared/PrintLayout';
import { HTTP_STATUS_CODE } from 'app/constants/ErrorConstants';
import AuthenticatedRoute from 'app/routes/AuthenticatedRoute';
import AccountRequiredRoute from 'app/routes/AccountRequiredRoute';
import UsersPageRoute from '../users/UsersPageRoute';
import CheckedOutPrintListRoute from './CheckedOutPrintListRoute';
import HoldsPrintListRoute from './HoldsPrintListRoute';
import InterlibraryLoansPrintListRoute from './InterlibraryLoansPrintListRoute';
import RecentlyReturnedPrintListRoute from './RecentlyReturnedPrintListRoute';
import SearchPrintListRoute from './SearchPrintListRoute';
import ShelfPrintListRoute from './ShelfPrintListRoute';

const basePath = '/v2/print';

export default (
  <Route
    path="/v2/print"
    element={
      <PrintLayout>
        <Outlet />
      </PrintLayout>
    }
  >
    <Route
      path={`${basePath}/checkedout/:status?`}
      element={
        <AuthenticatedRoute>
          <AccountRequiredRoute>
            <CheckedOutPrintListRoute />
          </AccountRequiredRoute>
        </AuthenticatedRoute>
      }
    />
    <Route
      path={`${basePath}/holds/:status?`}
      element={
        <AuthenticatedRoute>
          <AccountRequiredRoute>
            <HoldsPrintListRoute />
          </AccountRequiredRoute>
        </AuthenticatedRoute>
      }
    />
    <Route
      path={`${basePath}/interlibraryloans/:status?`}
      element={
        <AuthenticatedRoute>
          <AccountRequiredRoute>
            <InterlibraryLoansPrintListRoute />
          </AccountRequiredRoute>
        </AuthenticatedRoute>
      }
    />
    <Route
      path={`${basePath}/recentlyreturned/*`}
      element={
        <AuthenticatedRoute>
          <AccountRequiredRoute>
            <RecentlyReturnedPrintListRoute />
          </AccountRequiredRoute>
        </AuthenticatedRoute>
      }
    />
    <Route path={`${basePath}/search/*`} element={<SearchPrintListRoute />} />
    <Route
      path={`${basePath}/users/:userId/shelves/:shelfName/*`}
      element={
        <UsersPageRoute>
          <ShelfPrintListRoute />
        </UsersPageRoute>
      }
    />
    {/* v6 ranks a splat below an index route, so without this the parent's OWN path matches
        the layout alone and <Outlet /> renders nothing -- an empty 200, not the 404. */}
    <Route index element={<ErrorPage httpStatusCode={HTTP_STATUS_CODE.NOT_FOUND} />} />
    <Route path="*" element={<ErrorPage httpStatusCode={HTTP_STATUS_CODE.NOT_FOUND} />} />
  </Route>
);
